import { useMemo } from 'react';
import { AddonPurchaseBridge } from '@/features/billing';
import { useFlexStorage } from '../hooks/use-flex-storage';
import { useOpenStoragePacks } from '../hooks/use-open-storage-packs';

/** The add-on bridge, with the account's storage for stored-profile requests from Ember. */
export function AddonPurchaseBridgeWithStorage() {
  const flexStorage = useFlexStorage();
  const { refresh } = useOpenStoragePacks();

  const stored = flexStorage.status === 'ready' ? flexStorage.storage.stored : null;
  const limit = flexStorage.status === 'ready' ? flexStorage.storage.limit : null;
  const storage = useMemo(() => {
    if (stored == null || limit == null) return null;
    return { stored, limit };
  }, [stored, limit]);

  return <AddonPurchaseBridge storage={storage} onStoragePurchased={refresh} />;
}
